import request from 'utils/request';
import config from 'config/Config';

export default class {
  static getTaskList(params) {
    return request({
      host: config.HOST_PROMOTE,
      url: `agenda/schedule/list`,
      params
    });
  }

  // 修改日程状态
  static alterTaskStatus(params) {
    return request({
      host: config.HOST_PROMOTE,
      url: `agenda/status/update`,
      method: 'post_json',
      data: params
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/Promote/Schedule/DetailedList/DetailedListServ.js